<mat-card class="mat-elevation-z0 edit-line-note-card">
  <mat-card-content>
    <form [formGroup]="form">
      <div class="row">
        <div class="col">
          <p class="product-name">{{ productSkuName }}</p>
        </div>
      </div>
      <mat-form-field class="note-text-area" appearance="fill">
        <mat-label>Line Note</mat-label>
        <textarea matInput
               formControlName="note"
               name="note"
               id="note"
               type="text"
        >
        </textarea>
      </mat-form-field>
    </form>
  </mat-card-content>
</mat-card>
